type KeysOfUnion<T> = T extends T ? keyof T : never;

export const findUnionMember = <T, K extends KeysOfUnion<T>>(
  items: readonly T[] | null | undefined,
  key: K,
): Extract<T, Record<K, unknown>> | undefined =>
  items?.find(
    (item): item is Extract<T, Record<K, unknown>> =>
      !!item && typeof item === 'object' && key in item,
  );
